<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/transmission/DHT2/DHT2.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">2DHT70</div>
                <div class="detail-banner-desc transmission">Single-motor 2-speed DHT
                    <div class="detail-desc">
                        <div>
                            The assembly features a highly integrated design, a single-motor two-speed architecture, and a lightweight construction;<br />
                        </div>
                        <div>
                            When paired with the P4 electric bridge, it enables multiple two- and four-wheel-drive modes—including two pure-electric modes, two direct-drive modes, series hybrid, 
                            and combined hybrid—thus optimizing the vehicle’s fuel efficiency across all operating conditions. The system incorporates a high-efficiency flat-wire motor, a high-efficiency controller, 
                            and an intelligent control strategy that precisely identifies the motor’s efficient operating range;<br />
                        </div>
                        <div>
                            It employs a high-efficiency flat-wire motor, a high-efficiency controller, and an intelligent control strategy that precisely identifies the motor’s high-efficiency operating range. 
                            Combined with high-precision gears featuring low slip rates and high-efficiency bearings, this system achieves exceptionally high transmission efficiency.<br />
                        </div>

                    </div></div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="one-titile">
                    Core Configuration
                </div>

                <div class="spec-row">  
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">70kW</div>
                                    <div class="k">Peak Power</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">160N·m</div>
                                    <div class="k">Peak Torque</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">14000rpm</div>
                                    <div class="k">Maximum Speed</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">2</div>
                                    <div class="k">Gear</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="spec-image img-box">
                        <img src="/assets/product/transmission/DHT2/DHT2-2.jpg" alt="200-1-02">
                    </div>
                </div>

            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
  title: '2DHT70 - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/transmission/DHT2.html'

};

import { createApp } from 'vue';
import App from './DHT2.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./DHT2.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
